import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { db } from "../components/Firebase";
import Loader from "../components/Loader";
import create from "../assets/images/create.jpeg";
import "./checkbox.css";
import moment from "moment";

const Users = () => {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    getUsers()
  }, []);

  const getUsers = () => {
    db.collection("user")
      .get()
      .then((i) => {
        let newUsers = [];
        i.forEach((i) => {
          //console.log(i.data())
          newUsers.push({ ...i.data(), id: i.id });
        });
        setUsers([...newUsers]);
      });
  }

  const onChange = (cricketGearsEnabled,id) => {
    db.collection("user")
      .doc(id)
      .update({
        cricketGearsEnabled
      })
      .then(() => {
        getUsers()
      });
  }

  return (
    <div class="container-fluid">
  <div class="container">
    <div class="row">
      <div class="col-md-12" style={{height: "600px", overflowY: 'scroll'}}>
        <h1 style={{ textAlign: "center" }}>Users</h1>
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Cricket Gears</th>
              <th>Address</th>
              <th>Bat Size</th>
              <th>D O B</th>
              <th>Gloves Size</th>
              <th>Helmet Size</th>
              <th>Nationality</th>
              <th>Number</th>
              <th>Role</th>
              <th>Shirt Number</th>
              <th>Shirt Size</th>
              <th>Shoe Size</th>
              <th>Trouser Length</th>
              <th>Image</th>
            </tr>
          </thead>
          <tbody>
            {users.map((i) => {
                   return (
            <tr>
              <td>{i.firstName + ' ' + i.lastName}</td>
              <td>{i.email}</td>
              <td><label class="switch"><input type="checkbox" checked={i.cricketGearsEnabled} onChange={e => onChange(e.target.checked,i.id)} /> <span class="slider round"></span> </label></td>
              <td>{i.address}</td>
              <td>{i.batSize}</td>
              <td>{i.dob ? moment(i.dob).format('DD MMM, YYYY') : null}</td>
              <td>{i.glovesSize}</td>
              <td>{i.helmetSize}</td>
              <td>{i.nationailty}</td>
              <td>{i.number}</td>
              <td>{i.role}</td>
              <td>{i.shirtNumber}</td>
              <td>{i.shirtSize}</td>
              <td>{i.shoeSize}</td>
              <td>{i.trouserLength}</td>
              <td>{i.imageUrl ? <a href={i.imageUrl}>Click to view</a> : null}</td>
            </tr>
            );
                 })}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
  );
};

export default Users;
